export const CLEAR_RULE_ALARM_TIME = 'clearRuleAlarmTime'

export function clearLocalStorage() {
  localStorage.clear()
}

export function setClearRuleAlarmTime(timestamp) {
  localStorage.setItem(CLEAR_RULE_ALARM_TIME, timestamp)
}

export function getClearRuleAlarmTime() {
  return Number(localStorage.getItem(CLEAR_RULE_ALARM_TIME))
}
